import cn from 'classnames'
import * as React from 'react'

import { FieldWrapper } from 'components/FieldWrapper'
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper'

import styles from './TextField.module.scss'

export interface TextFieldProps extends React.HTMLProps<HTMLInputElement> {
  icon?: React.ReactNode
  closeIcon?: React.ReactNode
  inputSize?: 'small' | 'medium'
  handleSearchAddress?: () => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const TextField = React.forwardRef<
  HTMLInputElement,
  TextFieldProps & FieldWrapperProps
>(
  (
    {
      label,
      icon,
      inputSize = 'medium',
      error,
      withError,
      required,
      handleSearchAddress,
      closeIcon,
      ...props
    },
    ref,
  ) => {
    const inputSizeStyle = {
      small: styles.inputSmall,
      medium: styles.inputMedium,
    }

    // @ts-ignore
    return (
      <FieldWrapper
        error={error}
        withError={withError}
        label={label}
        required={required}
      >
        <div
          className={cn(
            styles.inputContainer,
            icon ? styles.inputContainer__icon : null,
          )}
        >
          <input
            ref={ref}
            type="text"
            className={cn(styles.input, inputSizeStyle[inputSize])}
            {...props}
          />
          {
            <button
              type={'button'}
              onClick={handleSearchAddress}
              className={styles.icon}
            >
              {icon}
            </button>
          }
          {
            <button
              type={'button'}
              className={styles.closeIcon}
            >
              {closeIcon}
            </button>
          }
        </div>
      </FieldWrapper>
    )
  },
)
